import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { StoreService } from '../../core/store.service';
import { BaseStore, StagesModel, eItem, SessionItem, CategorieModel, CatalogsModel, ProductsModel, Product, WSRegMode } from '../../shared';
import { HttpService, EndWithSlash } from 'projects/lib-components/src/public_api';
import { PathName } from '../../shared/path.model';

@Component({
  selector: 'webstore-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.css']
})

export class BaseComponent extends BaseStore implements OnInit {

  isLoggedIn: boolean = true;
  hasCursus: boolean = false;
  hasStages: boolean = false;

  facebook: string = '';
  twitter: string = '';
  linkedin: string = '';
  viadeo: string = '';

  constructor(
    protected store: StoreService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected http: HttpService
  ) {
    super(store);
    //////route.params.subscribe((val: Params) => {
    //////  this.initData();
    //////});
  }

  alertImplement(): void {
    this.store.showAlert('to implement');
  }

  ngOnInit(): void {
    this.isLoggedIn = this.store.InitOk;
    this.hasCursus = this.store.countCursus > 0; //////////////////// this.store.cursusList.length > 0;
    this.hasStages = this.store.countStages > 0; //////////////////// this.store.stagesList.length > 0;
    this.store.ClearDataSession();  // each time we pass through the home page we need to clean the data in the session

    this.facebook = this.store.getStocked('Facebook');
    this.twitter = this.store.getStocked('Twitter');
    this.linkedin = this.store.getStocked('Linkedin');
    this.viadeo = this.store.getStocked('Viadeo');

    // ERREUR D'INITIALISATION DE L'APPLICATION
    if (this.isLoggedIn) {

      if (this.store.begin.goToCycleList === '1')
        super.openPage('CYC');  // go to /cursus/cyclelist
      else if (this.store.begin.goToStageList === '1')
        super.openPage('SES');  // go to /stages/lists
      else if (this.store.begin.goToCatalogueList === '1')
        super.openPage('CTL'); // go to /catalogsFormations/catalogs
      else if (this.isNumeric(this.store.begin.goToCategories_ByCatalogueID))
        this.redirectCategoriesLink();    // go to /catalogsFormations/categories (by catalogid)
      else if (this.isNumeric(this.store.begin.goToProducts_ByCategorieID))
        this.redirectProductsLink();      // go to /catalogsFormations/products (by categoryid)
      else if (this.isNumeric(this.store.begin.goToProduct_ByID)) {
        super.openPage('PRDLNK');         // go to /catalogsFormations/productlink
      }
      else if (this.isNumeric(this.store.begin.goToProductForm)) {
        this.redirectProductFormLink();           // go to formulaire
      }
      else if (this.isNumeric(this.store.begin.goToCycle_ByID)) {
        // to implement
      }
      else if (this.isNumeric(this.store.begin.goToCycleForm)) {
        // to implement
      }
      else if (this.isNumeric(this.store.begin.goToStage_ByID)) {
        this.redirectStageDetails();              // go to /stages/details
      }
      else if (this.isNumeric(this.store.begin.goToStageForm)) {
        this.redirectStageInscription();         // go to /inscriptions/formulaire
      }
      else this.store.showSplash(false);



      //////if (this.store.isStageLink) {
      //////  this.redirectStageLink();
      //////}
      //////else if (this.store.isCategorieLink) {
      //////  this.redirectCategorieLink();
      //////}
      //////else if (this.store.isCatalogueLink) {
      //////  this.redirectCatalogueLink();
      //////}
      //////else this.store.showSplash(false);
    }
    else {
      this.store.showSplash(false);
      this.store.showAlert(`Erreur lors de l'initialisation de l'application`);
    }
  }

  private isNumeric(value: string): boolean {
    if (value === '')
      return false;

    return !isNaN(parseInt(value)); // && isFinite(parseInt(n));
  }

  private redirectStageDetails(): void {
    const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/stageslist/getData/V2/FORMULAIRESTAGE/${this.store.begin.goToStage_ByID}`;
    this.http.getHttp<StagesModel>(destUrl).subscribe((response: StagesModel): void => {
      this.store.begin.goToStage_ByID = '';
      this.store.AppSettings.RegistrationMode = WSRegMode.PREINSCRIPTION;

      if (response.FormulaireStage.ParentProduct) {
        this.store.PathItem.SetPathItem(PathName.PRODUCT, response.FormulaireStage.ParentProduct.Ident, response.FormulaireStage.ParentProduct);
        if (response.FormulaireStage.ParentProduct.ParentCategory) {
          this.store.PathItem.SetPathItem(PathName.CATEGORY, response.FormulaireStage.ParentProduct.ParentCategory.Ident, response.FormulaireStage.ParentProduct.ParentCategory);
          if (response.FormulaireStage.ParentProduct.ParentCategory.ParentCatalogue) {
            this.store.PathItem.SetPathItem(PathName.CATALOG, response.FormulaireStage.ParentProduct.ParentCategory.ParentCatalogue.Ident, response.FormulaireStage.ParentProduct.ParentCategory.ParentCatalogue);
          }
        }
      }
      this.store.PathItem.SetPathItem(PathName.STAGE, response.FormulaireStage.Ident, response.FormulaireStage);

      // store data in session
      const item: SessionItem = new SessionItem(eItem.STAGE);
      item.id = response.FormulaireStage.Ident;
      item.desc = response.FormulaireStage.Info_PRO;
      item.jsData = JSON.stringify(response.FormulaireStage);
      this.store.AddDataSession(item);
      // .../stages/details
      this.router.navigateByUrl(this.store.AppRoutes.STAGEDETAILS);
    });
  }
  private redirectStageInscription(): void {
    const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/stageslist/getData/V2/FORMULAIRESTAGE/${this.store.begin.goToStageForm}`;
    this.http.getHttp<StagesModel>(destUrl).subscribe((response: StagesModel): void => {
      this.store.begin.goToStage_ByID = '';
      this.store.AppSettings.RegistrationMode = WSRegMode.PREINSCRIPTION;

      // -------------------- objects root --------------------
      if (response.FormulaireStage.ParentProduct) {
        this.store.PathItem.SetPathItem(PathName.PRODUCT, response.FormulaireStage.ParentProduct.Ident, response.FormulaireStage.ParentProduct);
        if (response.FormulaireStage.ParentProduct.ParentCategory) {
          this.store.PathItem.SetPathItem(PathName.CATEGORY, response.FormulaireStage.ParentProduct.ParentCategory.Ident, response.FormulaireStage.ParentProduct.ParentCategory);
          if (response.FormulaireStage.ParentProduct.ParentCategory.ParentCatalogue) {
            this.store.PathItem.SetPathItem(PathName.CATALOG, response.FormulaireStage.ParentProduct.ParentCategory.ParentCatalogue.Ident, response.FormulaireStage.ParentProduct.ParentCategory.ParentCatalogue);
          }
        }
      }
      this.store.PathItem.SetPathItem(PathName.STAGE, response.FormulaireStage.Ident, response.FormulaireStage);
      // -------------------- objects root --------------------

      // store data in session
      const item: SessionItem = new SessionItem(eItem.STAGE);
      item.id = response.FormulaireStage.Ident;
      item.desc = response.FormulaireStage.Info_PRO;
      item.jsData = JSON.stringify(response.FormulaireStage);
      this.store.AddDataSession(item);

      // .../inscriptions/formulaire
      this.router.navigateByUrl(this.store.AppRoutes.FORMMIXED);
    });
  }

  private redirectProductFormLink(): void {
    const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}/api/product/getData/V2/PRODUCTLINK/${this.store.begin.goToProductForm}`;
    this.result = this.http.getHttp<ProductsModel>(destUrl).subscribe((data: ProductsModel): void => {
      //////this.store.logPerf(new Date());
      if (!data.HasError) {

        this.store.begin.goToProductForm = '';
        this.store.AppSettings.RegistrationMode = WSRegMode.INFO;
        //this.store.begin.typeInscription = 'INFO-FORM';
        this.store.configModel = data.Config;

        const pd: Product = new Product();
        pd.Ident = data.ProductLink.Ident;
        pd.Code_PRO = data.ProductLink.Code_PRO;
        pd.DescrPRO = data.ProductLink.DescrPRO;
        pd.DesigPRO = data.ProductLink.DesigPRO;
        pd.DureePRO = data.ProductLink.DureePRO;
        //pd.Prix_PRO = data.ProductLink.Prix_PRO;
        pd.PricesList = data.ProductLink.PricesList;
        pd.NiforPRO = data.ProductLink.NiforPRO;
        pd.PubliPRO = data.ProductLink.PubliPRO;
        pd.PreRePRO = data.ProductLink.PreRePRO;
        pd.ProgrPRO = data.ProductLink.ProgrPRO;
        pd.PedagPRO = data.ProductLink.PedagPRO;
        pd.PrestPRO = data.ProductLink.PrestPRO;
        pd.PjextPRO = data.ProductLink.PjextPRO;

        pd.IdCategoriePere = data.ProductLink.ParentCategoryList.length > 0 ? data.ProductLink.ParentCategoryList[0].Ident : '0';
        if (data.ProductLink.ParentCategoryList.length > 0)
          pd.ParentCategory = data.ProductLink.ParentCategoryList[0];
        if (data.ProductLink.ResponsableList.length > 0)
          pd.Responsable = data.ProductLink.ResponsableList[0];
        pd.ProductStagesList = data.ProductLink.StagesList;
        pd.OptionalFields = data.ProductLink.OptionalFields;

        // -------------------- objects root --------------------
        if (data.ProductLink.ParentCategoryList.length > 0) {
          this.store.PathItem.SetPathItem(PathName.CATEGORY, data.ProductLink.ParentCategoryList[0].Ident, data.ProductLink.ParentCategoryList[0]);
          if (data.ProductLink.ParentCategoryList[0].ParentCatalogue) {
            this.store.PathItem.SetPathItem(PathName.CATALOG, data.ProductLink.ParentCategoryList[0].ParentCatalogue.Ident, data.ProductLink.ParentCategoryList[0].ParentCatalogue);
          }
        }
        this.store.PathItem.SetPathItem(PathName.PRODUCT, data.ProductLink.Ident, data.ProductLink);
        // -------------------- objects root --------------------

        //super.setProduct(pd);
        let item: SessionItem | null = this.getSession(eItem.PRODUCT);
        if (!item)
          item = new SessionItem(eItem.PRODUCT);

        item.id = pd.Ident;
        item.code = pd.Code_PRO;
        item.desc = pd.DescrPRO;
        item.jsData = JSON.stringify(pd);
        item.responsable = pd.Responsable;
        this.store.AddDataSession(item);
        // TRACE ERROR (do not remove this line)
        if (!pd.Responsable) this.store.traceData(`--PRODUCT IDENT ${pd.Ident} ${pd.DescrPRO} HAS NOT A SPECIFIED RESPONSABLE (from category)`);

        const pg: string = this.store.begin.access === 'MIXED'
          ? this.store.AppRoutes.FORMMIXED
          : this.store.AppRoutes.FORMEXTRANET;
        this.router.navigateByUrl(pg);
      }
    }, (error: any): void => { JSON.stringify(error); });
  }

  private redirectProductsLink(): void {
    const categoryID: string = this.store.begin.goToProducts_ByCategorieID;
    const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/categorie/getData/V2/SETCAT/${categoryID}`;
    this.http.getHttp<CategorieModel>(destUrl).subscribe((response: CategorieModel): void => {
      this.store.begin.goToProducts_ByCategorieID = '';
      this.store.AppSettings.RegistrationMode = WSRegMode.INFO;
      //this.store.begin.typeInscription = 'INFO-FORM';

      this.store.PathItem.SetPathItem(PathName.CATEGORY, response.Categorie.Ident, response.Categorie);

      let item: SessionItem | null = this.getSession(eItem.CATEGORY);
      if (!item)
        item = new SessionItem(eItem.CATEGORY);

      item.id = response.Categorie.Ident;
      item.desc = response.Categorie.Nom__CAT;
      item.jsData = JSON.stringify(response.Categorie);
      this.store.AddDataSession(item);
      // TRACE ERROR (do not remove this line)
      if (!response.Categorie.User_CAT || response.Categorie.User_CAT === '') this.store.traceData(`--CATEGORY IDENT ${response.Categorie.Ident} ${response.Categorie.Nom__CAT} HAS NOT A SPECIFIED USER (User_CAT)`);
      this.router.navigateByUrl(this.store.AppRoutes.PRODUCTS);
    });
  }

  private redirectCategoriesLink(): void {
    const catalogueID: string = this.store.begin.goToCategories_ByCatalogueID;
    const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/catalogue/getData/V2/INITCAT/${catalogueID}`;
    this.http.getHttp<CatalogsModel>(destUrl).subscribe((response: CatalogsModel): void => {
      if (!response.CatalogueList || response.CatalogueList.length === 0) {
        this.store.showAlert(`Aucun catalogue trouvé pour la categorie avec ident ${catalogueID}`);
        return;
      }

      this.store.begin.goToCategories_ByCatalogueID = '';
      this.store.AppSettings.RegistrationMode = WSRegMode.INFO;
      //this.store.begin.typeInscription = 'INFO-FORM';
      this.store.PathItem.SetPathItem(PathName.CATALOG, catalogueID, response.CatalogueList[0]);

      let item: SessionItem | null = this.getSession(eItem.CATALOG);
      if (!item)
        item = new SessionItem(eItem.CATALOG);

      item.id = response.CatalogueList[0].Ident;
      item.desc = response.CatalogueList[0].Name_CTL;
      item.jsData = JSON.stringify(response.CatalogueList[0]);
      this.store.AddDataSession(item);

      this.router.navigateByUrl(this.store.AppRoutes.CATEGORIES);
    });
  }
}
